<form nz-form nzLayout="vertical" [formGroup]="FG" (ngSubmit)="submit()">
    <!-- actions -->
    <div class="form-actions">
        <button
            nz-button
            [nzLoading]="loading$ | async"
            type="submit"
            [nzType]="'primary'"
        >
            Create
        </button>
    </div>
    <nz-divider></nz-divider>

    <!-- First Name -->
    <nz-form-item>
        <nz-form-label nzRequired>First Name</nz-form-label>
        <nz-form-control>
            <input
                type="text"
                nz-input
                placeholder="please enter the lead first name"
                formControlName="firstName"
            />
        </nz-form-control>
    </nz-form-item>

    <!-- Last Name -->
    <nz-form-item>
        <nz-form-label nzRequired>Last Name</nz-form-label>
        <nz-form-control>
            <input
                type="text"
                nz-input
                placeholder="please enter the lead last name"
                formControlName="lastName"
            />
        </nz-form-control>
    </nz-form-item>

    <!-- Email -->
    <nz-form-item>
        <nz-form-label nzRequired>Email</nz-form-label>
        <nz-form-control>
            <input
                type="email"
                nz-input
                placeholder="please enter the lead email"
                formControlName="email"
            />
        </nz-form-control>
    </nz-form-item>

    <!-- Phone -->
    <nz-form-item>
        <nz-form-label>Phone</nz-form-label>
        <nz-form-control>
            <input
                type="tel"
                nz-input
                placeholder="please enter the lead phone number"
                formControlName="phone"
            />
        </nz-form-control>
    </nz-form-item>

    <!-- dob -->
    <nz-form-item>
        <nz-form-label>DOB</nz-form-label>
        <nz-form-control>
            <nz-date-picker formControlName="dob"></nz-date-picker>
        </nz-form-control>
    </nz-form-item>

    <nz-form-item>
        <nz-form-control>
            <nz-form-label style="margin: 0; display: block"
                >Gender</nz-form-label
            >

            <nz-radio-group formControlName="gender">
                <label nz-radio-button nzValue="male">Male</label>
                <label nz-radio-button nzValue="female">Female</label>
                <label nz-radio-button nzValue="other">Other</label>
            </nz-radio-group>
        </nz-form-control>
    </nz-form-item>
</form>
